<template>
  <generic-modal :title="$t('billing')" ref="generic_modal" :is_wide="true">
    <form>
      <customer-info ref="customer_info" />
      <div class="is-divider"></div>
      <items-info ref="items_info" />
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
        v-bind:class="{ 'is-loading': loading }"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
  format_currency,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import CustomerInfo from "./Customer.vue";
import ItemsInfo from "./Items.vue";

export default {
  name: "EmitterModal",
  components: { GenericModal, CustomerInfo, ItemsInfo },
  props: {
    emitter_id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      meta: {},
      error: "",
      loading: false,
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      return false;
      // return !v.meta.certifier || !v.meta.name;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      let customer_data = v.$refs.customer_info.get_data();
      let items_data = v.$refs.items_info.get_data();
      let config = {
        customer: customer_data,
        items: items_data,
        emitter_id: v.emitter_id,
        // emitter_id: 11,
      };

      v.loading = true;
      v.$loader(true);
      put("/fel/bill", config)
        .then(() => {
          v.$emit("success");
          v.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        })
        .finally(() => {
          v.loading = false;
          v.$loader(false);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {};

      v.$refs.customer_info.clear();
      v.$refs.items_info.clear();

      v.$refs.customer_info.set_data({
        nit: "3952107-9",
        name: "Luis Robledo",
        email: "strato0100@gmail.com",
        address: "32 avenida 28-94 zona 5",
        zip_code: "01005",
        dpi_or_passport_number: "2528360220101",
        country: "GT",
        department: "Guatemala",
        municipality: "Guatemala",
      });

      v.error = "";
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
